// src/hooks/useHeaderLogic.js
import { useLogout } from './useLogout';
import { useSubscription } from './useSubscription';
import { useProfile } from './useProfile';
import { useDialog } from './useDialog';

export const useHeaderLogic = () => {
  const { logout } = useLogout();
  // const { isSubscription, isTest, checkSubscription } = useSubscription();
  const { isSubscription, checkSubscription } = useSubscription();
  const { profile, fetchProfile } = useProfile();

  return {
    logout,
    isSubscription,
    // isTest,
    checkSubscription,
    profile,
    fetchProfile,
  };
};
